export default __webpack_public_path__ + "static/media/pexels-suzy-hazelwood-2536965.7b3d0a26.jpg";